import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressIndictatorsModule } from '../progress-indicators/progress-indicators.module';
import { ColumnComponent } from './column/column.component';
import { ColumnGroupComponent } from './column-group/column-group.component';

@NgModule({
  declarations: [ColumnComponent, ColumnGroupComponent],
  imports: [CommonModule, ProgressIndictatorsModule],
  exports: [ColumnComponent, ColumnGroupComponent],
})
export class ColumnModule {}
